import * as actionTypes from 'constants/ActionTypes';

const vesselClaims = (state = {
    items: [],
    isLoaded: false,
    errors: [],
}, action) => {
    switch (action.type) {
    case actionTypes.GET_VESSEL_CLAIMS.REQUEST:
        return {
            ...state,
            items: [],
        };
    case actionTypes.GET_VESSEL_CLAIMS.SUCCESS: {
        return {
            ...state,
            items: action.data,
            isLoaded: true,
        };
    }
    case actionTypes.GET_VESSEL_CLAIMS.FAILURE:
        return {
            ...state,
            isLoaded: true,
            error: action.errors,
        };


    case actionTypes.ACCEPT_USER_CLAIMS_TO_VESSEL.REQUEST:
        return {
            ...state,
        };
    case actionTypes.ACCEPT_USER_CLAIMS_TO_VESSEL.SUCCESS: {
        const items = state.items.filter((vessel) => {
            return vessel._id !== action.vesselId;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.ACCEPT_USER_CLAIMS_TO_VESSEL.FAILURE: {
        return {
            ...state,
            errors: action.errors,
        };
    }
    case actionTypes.REJECT_USER_CLAIMS_TO_VESSEL.REQUEST:
        return {
            ...state,
        };
    case actionTypes.REJECT_USER_CLAIMS_TO_VESSEL.SUCCESS: {
        let items = state.items.map((vessel) => {
            if (vessel._id === action.vesselId) {
                let users = vessel.users.filter((user) => {
                    return user._id !== action.userId;
                });

                return {
                    ...vessel,
                    users,
                };
            }

            return vessel;
        });

        items = items.filter((vessel) => {
            return vessel.users.length > 0;
        });

        return {
            ...state,
            items,
        };
    }
    case actionTypes.REJECT_USER_CLAIMS_TO_VESSEL.FAILURE: {
        return {
            ...state,
            errors: action.errors,
        };
    }
    default:
        return state;
    }
};

export default vesselClaims;



// WEBPACK FOOTER //
// ./app/reducers/vessels/claims.js